import getVariantsProductVariantUtil from 'modules/product-variant/utils/get-variants'

/**
 * @param productVariantSample
 * @param sampledData
 * @returns {*}
 */
const getImageToDisplayOnCardUtil = ({
  productVariantSample,
  sampledData
}) => {
  const variantId = sampledData?.variantId

  let correctSampleVariant = null

  const variants = getVariantsProductVariantUtil(productVariantSample)

  if (variants?.length > 0) {
    correctSampleVariant = variants.find(
      variant => variant.variant_id === variantId
    )
  }

  if (correctSampleVariant) {
    return correctSampleVariant?.variant_image_url
  }

  return productVariantSample?.image_url
}

export default getImageToDisplayOnCardUtil
